var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
/** Uma linha de frase (texto + excluir), estilo campo cinza da imagem de referência. */
function PhraseRow(_a) {
    var value = _a.value, onDelete = _a.onDelete;
    return (_jsxs("div", __assign({ className: "phrase-row" }, { children: [_jsx("span", __assign({ className: "phrase-row-text" }, { children: value })), _jsx("button", __assign({ type: "button", className: "phrase-row-delete", onClick: onDelete, "aria-label": "Excluir" }, { children: _jsx(DeleteOutlineIcon, { fontSize: "small" }) }))] })));
}
export default PhraseRow;
